import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import "../index.css";

function DefaultBoard() {
    const [books, setBooks] = useState([]);
    const [lends, setLends] = useState([]);
    const [totalLendsToday, setTotalLendsToday] = useState(0);

    useEffect(() => {
        getAllBooks();
        getAllLendDetails();
        getTodaysLends();
    }, []);

    const getAllBooks = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND}/books`);
            setBooks(res.data);
        } catch (err) {
            console.error("Error fetching books:", err);
        }
    };

    const getAllLendDetails = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND}/lend`);
            setLends(res.data);
        } catch (err) {
            console.error("Error fetching lends:", err);
        }
    };

    const getTodaysLends = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND}/lend/today`);
            setTotalLendsToday(res.data.totalLendsToday);
        } catch (err) {
            console.error("Error fetching today's lendings:", err);
        }
    };

    return (
        <div className="dashboard-default container mt-4">
            <h1 className="dashboard-title mb-4"><b>Dashboard</b></h1>

            <div className="row g-4">
                {/* Dashboard Cards */}
                <div className="col-md-4">
                    <div className="dashboard-card card card-users">
                        <div className="card-body text-center">
                            <i className="bi bi-people display-4"></i>
                            <h3 className="card-title mt-2"><b>Total Users</b></h3>
                        </div>
                        <div className="card-footer text-center">
                            <Link to="/CustomerList" className="card-link">
                                More info <i className="bi bi-arrow-right-circle"></i>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="dashboard-card card card-bookings">
                        <div className="card-body text-center">
                            <i className="bi bi-calendar-check display-4"></i>
                            <h3 className="card-title mt-2"><b>Total Bookings</b></h3>
                        </div>
                        <div className="card-footer text-center">
                            <Link to="/AllBookings" className="card-link">
                                More info <i className="bi bi-arrow-right-circle"></i>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="dashboard-card card card-today">
                        <div className="card-body text-center">
                            <i className="bi bi-calendar-day display-4"></i>
                            <h3 className="card-title mt-2"><b>Bookings Today</b></h3>
                        </div>
                        <div className="card-footer text-center">
                            <Link to="/TodayBookings" className="card-link">
                                More info <i className="bi bi-arrow-right-circle"></i>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="dashboard-card card card-cars">
                        <div className="card-body text-center">
                            <i className="bi bi-car-front display-4"></i>
                            <h3 className="card-title mt-2"><b>Total Cars</b></h3>
                        </div>
                        <div className="card-footer text-center">
                            <Link to="/Carlists" className="card-link">
                                More info <i className="bi bi-arrow-right-circle"></i>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="dashboard-card card card-drivers">
                        <div className="card-body text-center">
                            <i className="bi bi-person-badge display-4"></i>
                            <h3 className="card-title mt-2"><b>Total Drivers</b></h3>
                        </div>
                        <div className="card-footer text-center">
                            <Link to="/DriverList" className="card-link">
                                More info <i className="bi bi-arrow-right-circle"></i>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="dashboard-card card card-date">
                        <div className="card-body text-center">
                            <i className="bi bi-calendar display-4"></i>
                            <h4 className="mt-2">{new Date().toLocaleDateString()}</h4>
                            <h3 className="card-title fs-5"><b>Date Today</b></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DefaultBoard;
